import "./CheckboxComponent.scss";
import {Checkbox, FormControlLabel} from '@mui/material';
import FormControl from "@mui/material/FormControl";

import React, { useEffect} from 'react';
import FormHelperText from '@mui/material/FormHelperText';

export interface CheckBoxComponentProps {
    name: string;
    value?: any;
    id?: string;
    label?: any;
    disabled?: boolean;
    required?: boolean;
    checked?: boolean;
    disableRipple?: boolean;
    indeterminate?: boolean;
    className?: string;
    size?: "medium" | "small" | undefined;
    color?: "error" | "primary" | "secondary" | "info" | "success" | "warning" | undefined;
    onUpdate?: Function;
    hasError?: boolean;
    errorMessage?: any;
}

const CheckBoxComponent = (props: CheckBoxComponentProps) => {

    const {
        name,
        id,
        disableRipple,
        indeterminate,
        label,
        value,
        disabled,
        onUpdate,
        required,
        hasError,
        errorMessage
    } = props;

    let {color, size, checked, className} = props;
    if (!color) color = "info";
    if (!size) size = "medium";
    if (!checked) checked = false;
    const [isChecked, setIsChecked] = React.useState<boolean|undefined>(checked);

    useEffect(() => {
        setIsChecked(props.checked);
    }, [props.checked]);

    return (
        <FormControl className="check-box-component-with-formik-wrapper" error={hasError}>
            <FormControlLabel label={label} className={className} control={<Checkbox
                color={color}
                size={size}
                disableRipple={disableRipple}
                checked={isChecked}
                indeterminate={indeterminate}
                id={id}
                name={name}
                required={required}
                disabled={disabled}
                value={value}
                onChange={(e) => {
                    const currentValue = e?.target?.checked;
                    setIsChecked(!isChecked);
                    if (onUpdate) {
                        onUpdate(currentValue);
                    }
                }}
            />}/>
            <FormHelperText>
                {hasError && <> {errorMessage} </>}
            </FormHelperText>
        </FormControl>
    );

};

export default CheckBoxComponent;